import { defineComponent as I, ref as N, computed as i, watch as o, watchEffect as g, provide as y, nextTick as E, createElementBlock as R, openBlock as n, createElementVNode as T, createBlock as d, createCommentVNode as v, normalizeClass as p, renderSlot as z, unref as f, withCtx as m, createVNode as h } from "vue";
import A from "./useMediaQuery.js";
import B from "./useStepper.js";
import w from "./Button.js";
import x from "./Icon.js";
import { S as L } from "./keys-C8Zfr_By.js";
var V = /* @__PURE__ */ ((r) => (r.VERTICAL = "vertical", r.HORIZONTAL = "horizontal", r))(V || {});
const P = { class: "tw-relative" }, Y = /* @__PURE__ */ I({
  __name: "Stepper",
  props: {
    step: { default: -1 },
    substep: { default: -1 },
    linear: { type: Boolean, default: !1 },
    orientation: { default: "vertical" },
    useResponsiveNav: { type: Boolean, default: !1 },
    theme: { default: "dark" }
  },
  emits: ["update:step", "update:substep"],
  setup(r, { expose: S, emit: b }) {
    const t = r, l = b, c = N(), e = B({
      linear: t.linear,
      activeStep: t.step,
      activeSubstep: t.substep,
      ref: c
    }), _ = A("screen and (min-width: 961px)"), a = i(
      () => t.orientation === "horizontal" && (!_.value || t.useResponsiveNav)
    ), k = i(() => e.activeStepIndex.value <= 0), C = i(
      () => !e.isStepCompleted(e.activeStepIndex.value) || e.activeStepIndex.value === e.steps.value.length - 1
    );
    o(
      () => t.step,
      (s) => e.activeStepIndex.value = s
    ), o(
      () => t.substep,
      (s) => e.activeSubstepIndex.value = s
    ), o(
      () => e.activeStepIndex.value,
      (s) => {
        l("update:step", s), u();
      }
    ), o(
      () => e.activeSubstepIndex.value,
      (s) => l("update:substep", s)
    ), g(() => {
      a.value && u();
    }), y(L, {
      registerStep: e.registerStep,
      orientation: t.orientation,
      stepCount: e.stepCount,
      theme: t.theme,
      showResponsiveNav: a
    }), S({
      back: e.back,
      next: e.next,
      goTo: e.goTo,
      isStepCompleted: e.isStepCompleted,
      isStepActive: e.isStepActive
    });
    async function u() {
      if (!a.value)
        return;
      await E();
      const s = e.activeStepElement.value;
      s && s.scrollIntoView({ behavior: "instant", inline: "start", block: "nearest" });
    }
    return (s, D) => (n(), R("div", P, [
      T("ul", {
        ref_key: "stepperListRef",
        ref: c,
        class: p(["stash-stepper tw-flex", {
          "tw-flex-col": t.orientation === "vertical",
          "stash-stepper--vertical": t.orientation === "vertical",
          "stash-stepper--horizontal": t.orientation === "horizontal",
          "tw-mx-9 tw-snap-x tw-snap-mandatory tw-overflow-x-hidden": a.value
        }]),
        "data-test": "stash-stepper"
      }, [
        z(s.$slots, "default")
      ], 2),
      a.value ? (n(), d(w, {
        key: 0,
        class: p(["stash-stepper__arrow stash-stepper__arrow--prev", t.theme === "light" ? "tw-text-blue-500" : "tw-text-white"]),
        "data-test": "stash-stepper|prev-arrow",
        disabled: k.value,
        icon: "",
        onClick: f(e).back
      }, {
        default: m(() => [
          h(x, {
            name: "chevron-left",
            size: "dense"
          })
        ]),
        _: 1
      }, 8, ["class", "disabled", "onClick"])) : v("", !0),
      a.value ? (n(), d(w, {
        key: 1,
        class: p(["stash-stepper__arrow stash-stepper__arrow--next", t.theme === "light" ? "tw-text-blue-500" : "tw-text-white"]),
        "data-test": "stash-stepper|next-arrow",
        disabled: C.value,
        icon: "",
        onClick: f(e).next
      }, {
        default: m(() => [
          h(x, {
            name: "chevron-right",
            size: "dense"
          })
        ]),
        _: 1
      }, 8, ["class", "disabled", "onClick"])) : v("", !0)
    ]));
  }
});
export {
  V as StepperOrientationEnum,
  Y as default
};
//# sourceMappingURL=Stepper.js.map
